import { Component, Input } from '@angular/core';
import { FormField, PetOwner, VetUser } from '@app/core/models';
import { MeasurementCodeType } from '@app/shared/utils';
import { SystemPreferenceCode } from '@app/shared/utils/enums/system-preference-code';
import { DataCSmaskDirective } from '../../directives/data-cs-mask.directive';
import { RcAttributeComponent } from '../rc-attribute/rc-attribute.component';
import { SafeHtmlPipe } from '@app/shared/pipes';

@Component({
  selector: 'app-profile-header',
  templateUrl: './profile-header.component.html',
  styleUrls: ['./profile-header.component.scss'],
  imports: [DataCSmaskDirective, RcAttributeComponent, SafeHtmlPipe],
})
export class ProfileHeaderComponent {
  @Input() imageUrl?: string;
  @Input() placeholderImageUrl?: string;
  @Input() headerTitle?: string;
  @Input() object?: VetUser | PetOwner;
  @Input() attributes?: FormField[];
  @Input() currentSystemPreferenceCode?: SystemPreferenceCode;
  @Input() currentBigMeasurementUnit?: MeasurementCodeType;
  @Input() public maskPii: boolean = false;
}
